import { default as _templateI9ZnPPy2iyMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/_template.vue?macro=true";
import { default as _91uuid_9373TgDj900nMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/[lang]/quick-view/[uuid].vue?macro=true";
import { default as ph_45onHbUnD0E9q2Meta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/[lang]/quick-view/ph-on.vue?macro=true";
import { default as reset_45passwordWr9ejNNgECMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/[lang]/reset-password.vue?macro=true";
import { default as set_45passwordxyJs1TRRfVMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/[lang]/set-password.vue?macro=true";
import { default as auto_45loginWaFCMt720bMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/auto-login.vue?macro=true";
import { default as billingNMrAKNfVOrMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/company-setting/billing.vue?macro=true";
import { default as employeeTu85izZk1gMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/company-setting/employee.vue?macro=true";
import { default as invitemVsSjKk6eLMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/company-setting/invite.vue?macro=true";
import { default as medical_45cardsdGtrgzlN1hMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/company-setting/medical-cards.vue?macro=true";
import { default as profilexYnsshAbadMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/company-setting/profile.vue?macro=true";
import { default as team90VWxwoZvNMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/company-setting/team.vue?macro=true";
import { default as contact_45uspRNNMN0N9sMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/contact-us.vue?macro=true";
import { default as admin_45submit_45claimubsEQf7ox6Meta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/claim-management/admin-submit-claim.vue?macro=true";
import { default as indexvy0J9sFtEJMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/claim-management/index.vue?macro=true";
import { default as _91uuid_93z7fGYxP09LMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/claim-management/view/[uuid].vue?macro=true";
import { default as coin_45managementRdR0Quz94DMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/coin-management.vue?macro=true";
import { default as createAwN2qV66BsMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/overview/create.vue?macro=true";
import { default as _91uuid_93PVvxKVo3w0Meta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/overview/edit/[uuid].vue?macro=true";
import { default as index0cSjTLiUZdMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/overview/index.vue?macro=true";
import { default as reports8pdn2UtxGXMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/reports.vue?macro=true";
import { default as setupo994APruKQMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/setup.vue?macro=true";
import { default as employee_45registration3VFTNuSB9gMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-registration.vue?macro=true";
import { default as faqP0BpPgIybIMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/faq.vue?macro=true";
import { default as forgot_45passwordgcXzUw9eDUMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/forgot-password.vue?macro=true";
import { default as get_45startedEm55EG2ZHyMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/get-started.vue?macro=true";
import { default as indexAHRB1fkjOhMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/index.vue?macro=true";
import { default as loginO8uF4Qqp59Meta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/login.vue?macro=true";
import { default as logoutl7Qdz3Y76MMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/logout.vue?macro=true";
import { default as _olds2IV9DtXXWMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/medical-card/_old.vue?macro=true";
import { default as indexW3lZbXFhlXMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/medical-card/index.vue?macro=true";
import { default as indexlbzGocBxWzMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/medical-card/purchase/index.vue?macro=true";
import { default as intro32IXmjFkMEMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/medical-card/purchase/intro.vue?macro=true";
import { default as registersetddZpRC4Meta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/medical-card/register.vue?macro=true";
import { default as indexYZav8ixr7gMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/claim-history/index.vue?macro=true";
import { default as _91uuid_93KpJmXufgWKMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/claim-history/view/[uuid].vue?macro=true";
import { default as enrolledOxZr6LI9LYMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/enrolled.vue?macro=true";
import { default as index0h5N53niv3Meta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/index.vue?macro=true";
import { default as no_45recordFJC7jaFBAoMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/no-record.vue?macro=true";
import { default as submit_45claimO2zu8Y8kSvMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/submit-claim.vue?macro=true";
import { default as submittedERoSyehrdNMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/submitted.vue?macro=true";
import { default as waiting_45for_45setupGLiyyjKRZQMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/waiting-for-setup.vue?macro=true";
import { default as consultation_45feeGvapJM3GXPMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/outpatient/consultation-fee.vue?macro=true";
import { default as consultation_45recordwhHo1RghOTMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/outpatient/consultation-record.vue?macro=true";
import { default as indexC38Gm4gXhzMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/outpatient/index.vue?macro=true";
import { default as panel_45doctor_45list5j62mkYd0vMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/outpatient/panel-doctor-list.vue?macro=true";
import { default as privacy_45policywKjgKzY1ofMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/privacy-policy.vue?macro=true";
import { default as redirectZYjRyOyQbuMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/redirect.vue?macro=true";
import { default as reset_45password4sL3tk77FcMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/reset-password.vue?macro=true";
import { default as set_45passwordgeguC2Vo2SMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/set-password.vue?macro=true";
import { default as terms_45and_45conditionsJI3NCKcoTVMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/terms-and-conditions.vue?macro=true";
import { default as token_45expiredfntmd64i01Meta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/token-expired.vue?macro=true";
import { default as update_45password09nD1cPxWdMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/update-password.vue?macro=true";
import { default as index1zixM2skakMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/user/index.vue?macro=true";
import { default as orderZVGLfkxbqTMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/user/order.vue?macro=true";
import { default as wellness9AcDct1zCnMeta } from "/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/wellness.vue?macro=true";
export default [
  {
    name: _templateI9ZnPPy2iyMeta?.name ?? "_template",
    path: _templateI9ZnPPy2iyMeta?.path ?? "/_template",
    meta: _templateI9ZnPPy2iyMeta || {},
    alias: _templateI9ZnPPy2iyMeta?.alias || [],
    redirect: _templateI9ZnPPy2iyMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/_template.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_9373TgDj900nMeta?.name ?? "lang-quick-view-uuid",
    path: _91uuid_9373TgDj900nMeta?.path ?? "/:lang()/quick-view/:uuid()",
    meta: _91uuid_9373TgDj900nMeta || {},
    alias: _91uuid_9373TgDj900nMeta?.alias || [],
    redirect: _91uuid_9373TgDj900nMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/[lang]/quick-view/[uuid].vue").then(m => m.default || m)
  },
  {
    name: ph_45onHbUnD0E9q2Meta?.name ?? "lang-quick-view-ph-on",
    path: ph_45onHbUnD0E9q2Meta?.path ?? "/:lang()/quick-view/ph-on",
    meta: ph_45onHbUnD0E9q2Meta || {},
    alias: ph_45onHbUnD0E9q2Meta?.alias || [],
    redirect: ph_45onHbUnD0E9q2Meta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/[lang]/quick-view/ph-on.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordWr9ejNNgECMeta?.name ?? "lang-reset-password",
    path: reset_45passwordWr9ejNNgECMeta?.path ?? "/:lang()/reset-password",
    meta: reset_45passwordWr9ejNNgECMeta || {},
    alias: reset_45passwordWr9ejNNgECMeta?.alias || [],
    redirect: reset_45passwordWr9ejNNgECMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/[lang]/reset-password.vue").then(m => m.default || m)
  },
  {
    name: set_45passwordxyJs1TRRfVMeta?.name ?? "lang-set-password",
    path: set_45passwordxyJs1TRRfVMeta?.path ?? "/:lang()/set-password",
    meta: set_45passwordxyJs1TRRfVMeta || {},
    alias: set_45passwordxyJs1TRRfVMeta?.alias || [],
    redirect: set_45passwordxyJs1TRRfVMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/[lang]/set-password.vue").then(m => m.default || m)
  },
  {
    name: auto_45loginWaFCMt720bMeta?.name ?? "auto-login",
    path: auto_45loginWaFCMt720bMeta?.path ?? "/auto-login",
    meta: auto_45loginWaFCMt720bMeta || {},
    alias: auto_45loginWaFCMt720bMeta?.alias || [],
    redirect: auto_45loginWaFCMt720bMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/auto-login.vue").then(m => m.default || m)
  },
  {
    name: billingNMrAKNfVOrMeta?.name ?? "company-setting-billing",
    path: billingNMrAKNfVOrMeta?.path ?? "/company-setting/billing",
    meta: billingNMrAKNfVOrMeta || {},
    alias: billingNMrAKNfVOrMeta?.alias || [],
    redirect: billingNMrAKNfVOrMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/company-setting/billing.vue").then(m => m.default || m)
  },
  {
    name: employeeTu85izZk1gMeta?.name ?? "company-setting-employee",
    path: employeeTu85izZk1gMeta?.path ?? "/company-setting/employee",
    meta: employeeTu85izZk1gMeta || {},
    alias: employeeTu85izZk1gMeta?.alias || [],
    redirect: employeeTu85izZk1gMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/company-setting/employee.vue").then(m => m.default || m)
  },
  {
    name: invitemVsSjKk6eLMeta?.name ?? "company-setting-invite",
    path: invitemVsSjKk6eLMeta?.path ?? "/company-setting/invite",
    meta: invitemVsSjKk6eLMeta || {},
    alias: invitemVsSjKk6eLMeta?.alias || [],
    redirect: invitemVsSjKk6eLMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/company-setting/invite.vue").then(m => m.default || m)
  },
  {
    name: medical_45cardsdGtrgzlN1hMeta?.name ?? "company-setting-medical-cards",
    path: medical_45cardsdGtrgzlN1hMeta?.path ?? "/company-setting/medical-cards",
    meta: medical_45cardsdGtrgzlN1hMeta || {},
    alias: medical_45cardsdGtrgzlN1hMeta?.alias || [],
    redirect: medical_45cardsdGtrgzlN1hMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/company-setting/medical-cards.vue").then(m => m.default || m)
  },
  {
    name: profilexYnsshAbadMeta?.name ?? "company-setting-profile",
    path: profilexYnsshAbadMeta?.path ?? "/company-setting/profile",
    meta: profilexYnsshAbadMeta || {},
    alias: profilexYnsshAbadMeta?.alias || [],
    redirect: profilexYnsshAbadMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/company-setting/profile.vue").then(m => m.default || m)
  },
  {
    name: team90VWxwoZvNMeta?.name ?? "company-setting-team",
    path: team90VWxwoZvNMeta?.path ?? "/company-setting/team",
    meta: team90VWxwoZvNMeta || {},
    alias: team90VWxwoZvNMeta?.alias || [],
    redirect: team90VWxwoZvNMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/company-setting/team.vue").then(m => m.default || m)
  },
  {
    name: contact_45uspRNNMN0N9sMeta?.name ?? "contact-us",
    path: contact_45uspRNNMN0N9sMeta?.path ?? "/contact-us",
    meta: contact_45uspRNNMN0N9sMeta || {},
    alias: contact_45uspRNNMN0N9sMeta?.alias || [],
    redirect: contact_45uspRNNMN0N9sMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: admin_45submit_45claimubsEQf7ox6Meta?.name ?? "employee-benefit-claim-management-admin-submit-claim",
    path: admin_45submit_45claimubsEQf7ox6Meta?.path ?? "/employee-benefit/claim-management/admin-submit-claim",
    meta: admin_45submit_45claimubsEQf7ox6Meta || {},
    alias: admin_45submit_45claimubsEQf7ox6Meta?.alias || [],
    redirect: admin_45submit_45claimubsEQf7ox6Meta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/claim-management/admin-submit-claim.vue").then(m => m.default || m)
  },
  {
    name: indexvy0J9sFtEJMeta?.name ?? "employee-benefit-claim-management",
    path: indexvy0J9sFtEJMeta?.path ?? "/employee-benefit/claim-management",
    meta: indexvy0J9sFtEJMeta || {},
    alias: indexvy0J9sFtEJMeta?.alias || [],
    redirect: indexvy0J9sFtEJMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/claim-management/index.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93z7fGYxP09LMeta?.name ?? "employee-benefit-claim-management-view-uuid",
    path: _91uuid_93z7fGYxP09LMeta?.path ?? "/employee-benefit/claim-management/view/:uuid()",
    meta: _91uuid_93z7fGYxP09LMeta || {},
    alias: _91uuid_93z7fGYxP09LMeta?.alias || [],
    redirect: _91uuid_93z7fGYxP09LMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/claim-management/view/[uuid].vue").then(m => m.default || m)
  },
  {
    name: coin_45managementRdR0Quz94DMeta?.name ?? "employee-benefit-coin-management",
    path: coin_45managementRdR0Quz94DMeta?.path ?? "/employee-benefit/coin-management",
    meta: coin_45managementRdR0Quz94DMeta || {},
    alias: coin_45managementRdR0Quz94DMeta?.alias || [],
    redirect: coin_45managementRdR0Quz94DMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/coin-management.vue").then(m => m.default || m)
  },
  {
    name: createAwN2qV66BsMeta?.name ?? "employee-benefit-overview-create",
    path: createAwN2qV66BsMeta?.path ?? "/employee-benefit/overview/create",
    meta: createAwN2qV66BsMeta || {},
    alias: createAwN2qV66BsMeta?.alias || [],
    redirect: createAwN2qV66BsMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/overview/create.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93PVvxKVo3w0Meta?.name ?? "employee-benefit-overview-edit-uuid",
    path: _91uuid_93PVvxKVo3w0Meta?.path ?? "/employee-benefit/overview/edit/:uuid()",
    meta: _91uuid_93PVvxKVo3w0Meta || {},
    alias: _91uuid_93PVvxKVo3w0Meta?.alias || [],
    redirect: _91uuid_93PVvxKVo3w0Meta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/overview/edit/[uuid].vue").then(m => m.default || m)
  },
  {
    name: index0cSjTLiUZdMeta?.name ?? "employee-benefit-overview",
    path: index0cSjTLiUZdMeta?.path ?? "/employee-benefit/overview",
    meta: index0cSjTLiUZdMeta || {},
    alias: index0cSjTLiUZdMeta?.alias || [],
    redirect: index0cSjTLiUZdMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/overview/index.vue").then(m => m.default || m)
  },
  {
    name: reports8pdn2UtxGXMeta?.name ?? "employee-benefit-reports",
    path: reports8pdn2UtxGXMeta?.path ?? "/employee-benefit/reports",
    meta: reports8pdn2UtxGXMeta || {},
    alias: reports8pdn2UtxGXMeta?.alias || [],
    redirect: reports8pdn2UtxGXMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/reports.vue").then(m => m.default || m)
  },
  {
    name: setupo994APruKQMeta?.name ?? "employee-benefit-setup",
    path: setupo994APruKQMeta?.path ?? "/employee-benefit/setup",
    meta: setupo994APruKQMeta || {},
    alias: setupo994APruKQMeta?.alias || [],
    redirect: setupo994APruKQMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-benefit/setup.vue").then(m => m.default || m)
  },
  {
    name: employee_45registration3VFTNuSB9gMeta?.name ?? "employee-registration",
    path: employee_45registration3VFTNuSB9gMeta?.path ?? "/employee-registration",
    meta: employee_45registration3VFTNuSB9gMeta || {},
    alias: employee_45registration3VFTNuSB9gMeta?.alias || [],
    redirect: employee_45registration3VFTNuSB9gMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/employee-registration.vue").then(m => m.default || m)
  },
  {
    name: faqP0BpPgIybIMeta?.name ?? "faq",
    path: faqP0BpPgIybIMeta?.path ?? "/faq",
    meta: faqP0BpPgIybIMeta || {},
    alias: faqP0BpPgIybIMeta?.alias || [],
    redirect: faqP0BpPgIybIMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: forgot_45passwordgcXzUw9eDUMeta?.name ?? "forgot-password",
    path: forgot_45passwordgcXzUw9eDUMeta?.path ?? "/forgot-password",
    meta: forgot_45passwordgcXzUw9eDUMeta || {},
    alias: forgot_45passwordgcXzUw9eDUMeta?.alias || [],
    redirect: forgot_45passwordgcXzUw9eDUMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/forgot-password.vue").then(m => m.default || m)
  },
  {
    name: get_45startedEm55EG2ZHyMeta?.name ?? "get-started",
    path: get_45startedEm55EG2ZHyMeta?.path ?? "/get-started",
    meta: get_45startedEm55EG2ZHyMeta || {},
    alias: get_45startedEm55EG2ZHyMeta?.alias || [],
    redirect: get_45startedEm55EG2ZHyMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/get-started.vue").then(m => m.default || m)
  },
  {
    name: indexAHRB1fkjOhMeta?.name ?? "index",
    path: indexAHRB1fkjOhMeta?.path ?? "/",
    meta: indexAHRB1fkjOhMeta || {},
    alias: indexAHRB1fkjOhMeta?.alias || [],
    redirect: indexAHRB1fkjOhMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginO8uF4Qqp59Meta?.name ?? "login",
    path: loginO8uF4Qqp59Meta?.path ?? "/login",
    meta: loginO8uF4Qqp59Meta || {},
    alias: loginO8uF4Qqp59Meta?.alias || [],
    redirect: loginO8uF4Qqp59Meta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/login.vue").then(m => m.default || m)
  },
  {
    name: logoutl7Qdz3Y76MMeta?.name ?? "logout",
    path: logoutl7Qdz3Y76MMeta?.path ?? "/logout",
    meta: logoutl7Qdz3Y76MMeta || {},
    alias: logoutl7Qdz3Y76MMeta?.alias || [],
    redirect: logoutl7Qdz3Y76MMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: _olds2IV9DtXXWMeta?.name ?? "medical-card-_old",
    path: _olds2IV9DtXXWMeta?.path ?? "/medical-card/_old",
    meta: _olds2IV9DtXXWMeta || {},
    alias: _olds2IV9DtXXWMeta?.alias || [],
    redirect: _olds2IV9DtXXWMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/medical-card/_old.vue").then(m => m.default || m)
  },
  {
    name: indexW3lZbXFhlXMeta?.name ?? "medical-card",
    path: indexW3lZbXFhlXMeta?.path ?? "/medical-card",
    meta: indexW3lZbXFhlXMeta || {},
    alias: indexW3lZbXFhlXMeta?.alias || [],
    redirect: indexW3lZbXFhlXMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/medical-card/index.vue").then(m => m.default || m)
  },
  {
    name: indexlbzGocBxWzMeta?.name ?? "medical-card-purchase",
    path: indexlbzGocBxWzMeta?.path ?? "/medical-card/purchase",
    meta: indexlbzGocBxWzMeta || {},
    alias: indexlbzGocBxWzMeta?.alias || [],
    redirect: indexlbzGocBxWzMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/medical-card/purchase/index.vue").then(m => m.default || m)
  },
  {
    name: intro32IXmjFkMEMeta?.name ?? "medical-card-purchase-intro",
    path: intro32IXmjFkMEMeta?.path ?? "/medical-card/purchase/intro",
    meta: intro32IXmjFkMEMeta || {},
    alias: intro32IXmjFkMEMeta?.alias || [],
    redirect: intro32IXmjFkMEMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/medical-card/purchase/intro.vue").then(m => m.default || m)
  },
  {
    name: registersetddZpRC4Meta?.name ?? "medical-card-register",
    path: registersetddZpRC4Meta?.path ?? "/medical-card/register",
    meta: registersetddZpRC4Meta || {},
    alias: registersetddZpRC4Meta?.alias || [],
    redirect: registersetddZpRC4Meta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/medical-card/register.vue").then(m => m.default || m)
  },
  {
    name: indexYZav8ixr7gMeta?.name ?? "my-benefit-claim-history",
    path: indexYZav8ixr7gMeta?.path ?? "/my-benefit/claim-history",
    meta: indexYZav8ixr7gMeta || {},
    alias: indexYZav8ixr7gMeta?.alias || [],
    redirect: indexYZav8ixr7gMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/claim-history/index.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93KpJmXufgWKMeta?.name ?? "my-benefit-claim-history-view-uuid",
    path: _91uuid_93KpJmXufgWKMeta?.path ?? "/my-benefit/claim-history/view/:uuid()",
    meta: _91uuid_93KpJmXufgWKMeta || {},
    alias: _91uuid_93KpJmXufgWKMeta?.alias || [],
    redirect: _91uuid_93KpJmXufgWKMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/claim-history/view/[uuid].vue").then(m => m.default || m)
  },
  {
    name: enrolledOxZr6LI9LYMeta?.name ?? "my-benefit-enrolled",
    path: enrolledOxZr6LI9LYMeta?.path ?? "/my-benefit/enrolled",
    meta: enrolledOxZr6LI9LYMeta || {},
    alias: enrolledOxZr6LI9LYMeta?.alias || [],
    redirect: enrolledOxZr6LI9LYMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/enrolled.vue").then(m => m.default || m)
  },
  {
    name: index0h5N53niv3Meta?.name ?? "my-benefit",
    path: index0h5N53niv3Meta?.path ?? "/my-benefit",
    meta: index0h5N53niv3Meta || {},
    alias: index0h5N53niv3Meta?.alias || [],
    redirect: index0h5N53niv3Meta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/index.vue").then(m => m.default || m)
  },
  {
    name: no_45recordFJC7jaFBAoMeta?.name ?? "my-benefit-no-record",
    path: no_45recordFJC7jaFBAoMeta?.path ?? "/my-benefit/no-record",
    meta: no_45recordFJC7jaFBAoMeta || {},
    alias: no_45recordFJC7jaFBAoMeta?.alias || [],
    redirect: no_45recordFJC7jaFBAoMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/no-record.vue").then(m => m.default || m)
  },
  {
    name: submit_45claimO2zu8Y8kSvMeta?.name ?? "my-benefit-submit-claim",
    path: submit_45claimO2zu8Y8kSvMeta?.path ?? "/my-benefit/submit-claim",
    meta: submit_45claimO2zu8Y8kSvMeta || {},
    alias: submit_45claimO2zu8Y8kSvMeta?.alias || [],
    redirect: submit_45claimO2zu8Y8kSvMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/submit-claim.vue").then(m => m.default || m)
  },
  {
    name: submittedERoSyehrdNMeta?.name ?? "my-benefit-submitted",
    path: submittedERoSyehrdNMeta?.path ?? "/my-benefit/submitted",
    meta: submittedERoSyehrdNMeta || {},
    alias: submittedERoSyehrdNMeta?.alias || [],
    redirect: submittedERoSyehrdNMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/submitted.vue").then(m => m.default || m)
  },
  {
    name: waiting_45for_45setupGLiyyjKRZQMeta?.name ?? "my-benefit-waiting-for-setup",
    path: waiting_45for_45setupGLiyyjKRZQMeta?.path ?? "/my-benefit/waiting-for-setup",
    meta: waiting_45for_45setupGLiyyjKRZQMeta || {},
    alias: waiting_45for_45setupGLiyyjKRZQMeta?.alias || [],
    redirect: waiting_45for_45setupGLiyyjKRZQMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/my-benefit/waiting-for-setup.vue").then(m => m.default || m)
  },
  {
    name: consultation_45feeGvapJM3GXPMeta?.name ?? "outpatient-consultation-fee",
    path: consultation_45feeGvapJM3GXPMeta?.path ?? "/outpatient/consultation-fee",
    meta: consultation_45feeGvapJM3GXPMeta || {},
    alias: consultation_45feeGvapJM3GXPMeta?.alias || [],
    redirect: consultation_45feeGvapJM3GXPMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/outpatient/consultation-fee.vue").then(m => m.default || m)
  },
  {
    name: consultation_45recordwhHo1RghOTMeta?.name ?? "outpatient-consultation-record",
    path: consultation_45recordwhHo1RghOTMeta?.path ?? "/outpatient/consultation-record",
    meta: consultation_45recordwhHo1RghOTMeta || {},
    alias: consultation_45recordwhHo1RghOTMeta?.alias || [],
    redirect: consultation_45recordwhHo1RghOTMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/outpatient/consultation-record.vue").then(m => m.default || m)
  },
  {
    name: indexC38Gm4gXhzMeta?.name ?? "outpatient",
    path: indexC38Gm4gXhzMeta?.path ?? "/outpatient",
    meta: indexC38Gm4gXhzMeta || {},
    alias: indexC38Gm4gXhzMeta?.alias || [],
    redirect: indexC38Gm4gXhzMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/outpatient/index.vue").then(m => m.default || m)
  },
  {
    name: panel_45doctor_45list5j62mkYd0vMeta?.name ?? "outpatient-panel-doctor-list",
    path: panel_45doctor_45list5j62mkYd0vMeta?.path ?? "/outpatient/panel-doctor-list",
    meta: panel_45doctor_45list5j62mkYd0vMeta || {},
    alias: panel_45doctor_45list5j62mkYd0vMeta?.alias || [],
    redirect: panel_45doctor_45list5j62mkYd0vMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/outpatient/panel-doctor-list.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policywKjgKzY1ofMeta?.name ?? "privacy-policy",
    path: privacy_45policywKjgKzY1ofMeta?.path ?? "/privacy-policy",
    meta: privacy_45policywKjgKzY1ofMeta || {},
    alias: privacy_45policywKjgKzY1ofMeta?.alias || [],
    redirect: privacy_45policywKjgKzY1ofMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: redirectZYjRyOyQbuMeta?.name ?? "redirect",
    path: redirectZYjRyOyQbuMeta?.path ?? "/redirect",
    meta: redirectZYjRyOyQbuMeta || {},
    alias: redirectZYjRyOyQbuMeta?.alias || [],
    redirect: redirectZYjRyOyQbuMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/redirect.vue").then(m => m.default || m)
  },
  {
    name: reset_45password4sL3tk77FcMeta?.name ?? "reset-password",
    path: reset_45password4sL3tk77FcMeta?.path ?? "/reset-password",
    meta: reset_45password4sL3tk77FcMeta || {},
    alias: reset_45password4sL3tk77FcMeta?.alias || [],
    redirect: reset_45password4sL3tk77FcMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: set_45passwordgeguC2Vo2SMeta?.name ?? "set-password",
    path: set_45passwordgeguC2Vo2SMeta?.path ?? "/set-password",
    meta: set_45passwordgeguC2Vo2SMeta || {},
    alias: set_45passwordgeguC2Vo2SMeta?.alias || [],
    redirect: set_45passwordgeguC2Vo2SMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/set-password.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionsJI3NCKcoTVMeta?.name ?? "terms-and-conditions",
    path: terms_45and_45conditionsJI3NCKcoTVMeta?.path ?? "/terms-and-conditions",
    meta: terms_45and_45conditionsJI3NCKcoTVMeta || {},
    alias: terms_45and_45conditionsJI3NCKcoTVMeta?.alias || [],
    redirect: terms_45and_45conditionsJI3NCKcoTVMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: token_45expiredfntmd64i01Meta?.name ?? "token-expired",
    path: token_45expiredfntmd64i01Meta?.path ?? "/token-expired",
    meta: token_45expiredfntmd64i01Meta || {},
    alias: token_45expiredfntmd64i01Meta?.alias || [],
    redirect: token_45expiredfntmd64i01Meta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/token-expired.vue").then(m => m.default || m)
  },
  {
    name: update_45password09nD1cPxWdMeta?.name ?? "update-password",
    path: update_45password09nD1cPxWdMeta?.path ?? "/update-password",
    meta: update_45password09nD1cPxWdMeta || {},
    alias: update_45password09nD1cPxWdMeta?.alias || [],
    redirect: update_45password09nD1cPxWdMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/update-password.vue").then(m => m.default || m)
  },
  {
    name: index1zixM2skakMeta?.name ?? "user",
    path: index1zixM2skakMeta?.path ?? "/user",
    meta: index1zixM2skakMeta || {},
    alias: index1zixM2skakMeta?.alias || [],
    redirect: index1zixM2skakMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/user/index.vue").then(m => m.default || m)
  },
  {
    name: orderZVGLfkxbqTMeta?.name ?? "user-order",
    path: orderZVGLfkxbqTMeta?.path ?? "/user/order",
    meta: orderZVGLfkxbqTMeta || {},
    alias: orderZVGLfkxbqTMeta?.alias || [],
    redirect: orderZVGLfkxbqTMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/user/order.vue").then(m => m.default || m)
  },
  {
    name: wellness9AcDct1zCnMeta?.name ?? "wellness",
    path: wellness9AcDct1zCnMeta?.path ?? "/wellness",
    meta: wellness9AcDct1zCnMeta || {},
    alias: wellness9AcDct1zCnMeta?.alias || [],
    redirect: wellness9AcDct1zCnMeta?.redirect || undefined,
    component: () => import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/pages/wellness.vue").then(m => m.default || m)
  }
]